// extracted by mini-css-extract-plugin
module.exports = {"faqWrapper":"_1W8-h","allFaqWrapper":"_1g10I","faqMainWrapper":"_22-jq","allfqa":"OCTu9"};